import { InvoiceParty } from '@/types'
import { Paper, Stack, Text } from '@mantine/core'

export default function InvoicePartyCard({ title, party }: { title: string; party: InvoiceParty }) {
  const cityLine = [party.postal_code, party.city].filter(Boolean).join(' ')

  return (
    <Paper withBorder radius="md" p="md">
      <Stack gap={2}>
        <Text size="xs" c="dimmed" tt="uppercase" fw={700}>
          {title}
        </Text>
        <Text fw={600}>{party.legal_name}</Text>
        {party.street_address && <Text size="sm">{party.street_address}</Text>}
        {cityLine && <Text size="sm">{cityLine}</Text>}
        <Text size="sm" c="dimmed" mt={4}>
          SIREN {party.siren ?? '—'}
          {party.vat_number ? ` · TVA ${party.vat_number}` : ''}
        </Text>
        {party.electronic_address && (
          <Text size="sm" c="dimmed">
            Adresse électronique {party.electronic_address}
          </Text>
        )}
      </Stack>
    </Paper>
  )
}
